import React from 'react';
import { Star, MapPin } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  initials: string;
  name: string;
  location: string;
  role: string;
  colorClass?: string;
}
export function TestimonialCard({
  quote,
  initials,
  name,
  location,
  role,
  colorClass = 'bg-aqua-600'
}: TestimonialCardProps) {
  return <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-xl shadow-slate-200/50 border border-slate-100 flex flex-col h-full relative" data-id="element-352">
      <div className="absolute top-4 md:top-6 right-4 md:right-6 text-aqua-200 opacity-50" data-id="element-353">
        <svg width="28" height="28" className="md:w-10 md:h-10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-354">
          <path d="M14.017 21L16.411 14.603C18.805 14.603 20 13.408 20 11.014C20 8.62 18.805 7.425 16.411 7.425C14.017 7.425 12.822 8.62 12.822 11.014C12.822 13.408 14.017 21 14.017 21ZM5.017 21L7.411 14.603C9.805 14.603 11 13.408 11 11.014C11 8.62 9.805 7.425 7.411 7.425C5.017 7.425 3.822 8.62 3.822 11.014C3.822 13.408 5.017 21 5.017 21Z" data-id="element-355" />
        </svg>
      </div>

      <div className="flex gap-0.5 mb-2 md:mb-4" data-id="element-356">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-yellow-400 text-yellow-400" data-id="element-357" />)}
      </div>

      <p className="text-slate-700 italic mb-3 md:mb-6 flex-grow relative z-10 text-sm md:text-lg" data-id="element-358">
        "{quote}"
      </p>

      <div className="flex items-center gap-3 mt-auto pt-3 md:pt-4 border-t border-slate-100" data-id="element-359">
        <div className={`w-9 h-9 md:w-12 md:h-12 rounded-full ${colorClass} text-white flex items-center justify-center font-display font-bold text-sm md:text-lg shadow-inner`} data-id="element-360">
          {initials}
        </div>
        <div data-id="element-361">
          <h4 className="font-bold text-deepblue-900 text-sm md:text-base" data-id="element-362">
            {name}
          </h4>
          <div className="flex items-center gap-1 text-[10px] md:text-xs text-slate-500 mb-0.5" data-id="element-363">
            <MapPin className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-364" /> {location}
          </div>
          <p className="text-[10px] md:text-xs font-medium text-aqua-700 uppercase tracking-wide" data-id="element-365">
            {role}
          </p>
        </div>
      </div>
    </div>;
}